
import { computed, defineComponent, onBeforeMount, reactive } from 'vue';
import { spin } from '@tencent/web-vbui/src/components/t-spin/spin';
import { Slide } from './components';
// import {
//   openSharePanel,
//   shareLink,
//   AllChanel,
//   ShareChannel,
//   isCommonError,
//   CallErrorType,
// } from '@tencent/vb-app-bridge';
// import { ShareResponse } from '@tencent/vb-app-bridge/lib/src/type/share';
import { i18n, reportStatistics, setShareInfo, shareLink } from '@tencent/vb-web-base';
import { to, isIos, isWeChat } from '@tencent/vb-web-base-core';
import { baseMixins } from '@common/mixins/baseMixins';
import { GetLoanConfigList } from '../../core/network/NodeAPI';
import {
  ILoanLeaseItem,
  ILoanLeaseIntegrateConfig,
  ILoanLeaseItemResp,
  ILoanLeaseConfigResp,
} from '../../core/interface/IModel';
import { getUrl, getQuery, setQuery } from '@tencent/multi-url';
export default defineComponent({
  components: {
    Slide,
  },
  setup() {
    const isApp = window.navigator.userAgent.indexOf('VB') > -1;
    const { setTitle, getLanguage, showModal, showModalError } = baseMixins();
    const { id = 'RNPL01' } = getQuery();
    // 活动页面配置
    const configInfo = reactive<ILoanLeaseIntegrateConfig>({
      integrateTitle: '',
      integrate: [],
      slide: [],
      protocol: [],
    });
    // 多语言设置标题
    const lang = getLanguage();
    const { getT } = i18n;
    const $t = getT();
    // setTitle($t('快闪优惠'));

    const formatParam = (p: string): ILoanLeaseItem[] => {
      let config: ILoanLeaseItemResp[];
      try {
        config = JSON.parse(p);
      } catch (err) {
        config = [];
      }
      return config
        .map((item) => {
          if (!item.link) {
            // eslint-disable-next-line no-param-reassign
            item.link = item[`link_${lang}`];
          }
          return {
            image: item[lang],
            ...item,
          };
        })
        .filter((item) => {
          if (item.channel === 'other' && isApp) {
            return false;
          }
          if (item.channel === 'app' && !isApp) {
            return false;
          }
          return true;
        });
    };

    const formatTextParam = (p: string): string => {
      let config: ILoanLeaseItemResp[];
      try {
        config = JSON.parse(p);
      } catch (err) {
        config = [];
      }
      return config[0]?.[lang];
    };

    // 获取入口配置
    const getConfigInfo = async () => {
      const [data, err] = await to(GetLoanConfigList<{ content: ILoanLeaseConfigResp[] }>('loan_lease_V2'));
      if (err) {
        showModalError(err.message, err.code);
        return;
      }
      if (data?.content?.length) {
        const config = data.content.find((item) => item.id === id);
        if (config) {
          configInfo.integrateTitle = formatTextParam(config.integrateTitle as unknown as string);
          // 设置页面标题
          setTitle(configInfo.integrateTitle);
          configInfo.integrate = formatParam(config.integrate as unknown as string);
          configInfo.slide = formatParam(config.slide as unknown as string);
          configInfo.protocol = formatParam(config.protocol as unknown as string);
        } else {
          showModalError($t('活动已结束'));
        }
      }
    };

    const getShareInfo = () => {
      let link = getUrl();
      link = setQuery(link, 'lang', lang);
      /* eslint-disable */
      const thumbPath = require('@/assets/images/lease/sharenew.png');
      return {
        /* eslint-disable */
        thumbPath: `https:${thumbPath}`,
        desc: '',
        title: $t('贷款优惠'),
        content: $t('点击以了解详情! 受条款及细则约束。借定唔借 ? 还得到先好借 !'),
        link,
      };
    };

    // const initWxShare = () => {
    //   if (isWeChat) {
    //     const { title, link, thumbPath, content } = getShareInfo();
    //     wxBridge.setShareInfo({
    //       title,
    //       desc: content,
    //       link,
    //       imgUrl: thumbPath,
    //     });
    //   }
    // };

    const initShare = () => {
      const { title, link, thumbPath, content } = getShareInfo();
      setShareInfo({
        linkContent: link,
        wxDesc: content,
        wxTitle: title,
        link,
        wxThumbPath: thumbPath,
      });
    };

    const slideTop = computed(() => configInfo.integrate.filter((item) => item?.position === 'top'));
    const slideBottom = computed(() => configInfo.integrate.filter((item) => item?.position === 'bottom'));

    const handleClick = async (item: ILoanLeaseItem) => {
      if (item.link) {
        let { link } = item;
        if (item.key) {
          await reportStatistics({ evtName: item.key });
        }
        const url = setQuery(item.link, 'lang', lang);
        link = url;
        if (link.includes('https://wa.me') || link.includes('https://api.whatsapp.com')) {
          if (isApp) {
            return;
          }
          const res = await showModal($t('您将离开本网站，并对外连接至第三方网站'), $t('您将离开本网站'), $t('取消'));
          if (res === 'cancel') {
            return;
          }
        }
        window.top!.location.href = link;
      }
    };

    // 分享活动
    const handleShare = async () => {
      const { link, title, content, thumbPath } = getShareInfo();
      reportStatistics({
        evtName: 'share',
        desc: '快闪优惠活动分享按钮点击',
      });
      shareLink();
      // try {
      //   const allChanels: AllChanel[] = isIos
      //     ? [
      //         ShareChannel.FACEBOOK,
      //         ShareChannel.WECHAT_MESSAGE,
      //         ShareChannel.WECHAT_MOMENT,
      //         ShareChannel.MESSENGER,
      //         ShareChannel.MORE,
      //       ]
      //     : [
      //         ShareChannel.WHATSAPP,
      //         ShareChannel.FACEBOOK,
      //         ShareChannel.WECHAT_MESSAGE,
      //         ShareChannel.WECHAT_MOMENT,
      //         ShareChannel.MESSENGER,
      //         ShareChannel.MORE,
      //       ];
      //   const channel = await openSharePanel(allChanels);
      //   if (channel === ShareChannel.UNKNOWN) {
      //     // 需要处理未知的渠道
      //     return;
      //   }
      //   /* eslint-disable */
      //   const result = await shareLink(channel, {
      //     thumbPath,
      //     title,
      //     link,
      //     content,
      //   });
      //   if (result.result === '0') {
      //     reportStatistics({
      //       evtName: 'shareSuccess',
      //       desc: '快闪优惠活动分享成功',
      //     });
      //   }
      // } catch (err) {
      //   if (isCommonError(err)) {
      //     if (err.type === CallErrorType.OTHER_ERROR) {
      //       const { msg, result } = err.result as ShareResponse;
      //       if (result !== '0') {
      //         reportStatistics({
      //           evtName: 'shareError',
      //           desc: '快闪优惠活动分享失败',
      //         });
      //       }
      //       if (result === '-2') {
      //         showModalError(msg);
      //       }
      //       console.log(msg);
      //       // 0    分享成功
      //       // -1    分享失败
      //       // -2    分享渠道对应app没安装
      //       // -3    用户主动取消
      //       // -4    相册权限未经用户授权    涉及图片操作时需要该权限
      //     }
      //   }
      // }
    };

    onBeforeMount(async () => {
      spin.show();
      await getConfigInfo();
      spin.hide();
      initShare();
    });
    return {
      isApp,
      configInfo,
      slideTop,
      slideBottom,
      handleClick,
      handleShare,
    };
  },
});
